export default "__VITE_ASSET__2LI2a6Hf__"